import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "text", "secondary", "disabled", "tabIndex", "type", "icon", "onClick", "justify", "img", "fullwidth"];
import React from 'react';
import { COLORS, ELEVATIONS, SIZES } from '../styleVars';
import styled from 'styled-components';
import { Typography } from '../typography/Typography';
var Container = styled.div.withConfig({
  componentId: "sc-18mybjt-0"
})(["display:flex;justify-content:", ";width:", ";button{width:inherit;display:flex;justify-content:", ";align-items:center;min-width:", ";height:", ";padding:0 ", ";text-transform:uppercase;background-color:", ";border:none;border-radius:", ";outline:none;-webkit-tap-highlight-color:transparent;box-shadow:", ";cursor:pointer;}button:hover,button:focus{background-color:", ";}"], function (props) {
  return props.justify;
}, function (props) {
  return props.fullwidth ? '14.5rem' : 'auto';
}, function (props) {
  return props.fullwidth ? 'flex-start' : 'center';
}, SIZES['72'], SIZES['36'], SIZES['16'], function (props) {
  return props.bgColor;
}, SIZES['2'], function (props) {
  return props.elevation;
}, function (props) {
  return props.focusColor;
});
var IconContainer = styled.div.withConfig({
  componentId: "sc-18mybjt-1"
})(["display:inline;align-items:center;height:", ";width:", ";margin-right:", ";margin-left:-", ";"], SIZES['24'], SIZES['24'], SIZES['12'], SIZES['4']);
var Label = styled(Typography).withConfig({
  componentId: "sc-18mybjt-2"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);

var Button = function Button(_ref) {
  var label = _ref.label,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? false : _ref$text,
      _ref$secondary = _ref.secondary,
      secondary = _ref$secondary === void 0 ? false : _ref$secondary,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      icon = _ref.icon,
      onClick = _ref.onClick,
      _ref$justify = _ref.justify,
      justify = _ref$justify === void 0 ? 'flex-start' : _ref$justify,
      img = _ref.img,
      _ref$fullwidth = _ref.fullwidth,
      fullwidth = _ref$fullwidth === void 0 ? false : _ref$fullwidth,
      props = _objectWithoutProperties(_ref, _excluded);

  var buttonConfig = {
    typoVariant: 'button-primary',
    backgroundColor: COLORS.fupaSecondary,
    elevation: ELEVATIONS.Button,
    focusColor: COLORS.fupaSecondaryFocused
  };

  if (text && !disabled && secondary) {
    buttonConfig = {
      typoVariant: 'button-sub',
      backgroundColor: 'transparent',
      elevation: 'none',
      focusColor: COLORS.lighterGrey
    };
  } else if (text && !disabled) {
    buttonConfig = {
      typoVariant: 'button-secondary',
      backgroundColor: 'transparent',
      elevation: 'none',
      focusColor: COLORS.lighterGrey
    };
  } else if (text && disabled) {
    buttonConfig = {
      typoVariant: 'button-disabled',
      backgroundColor: 'transparent',
      elevation: 'none',
      focusColor: COLORS.lighterGrey
    };
  } else if (secondary && !disabled) {
    buttonConfig = {
      typoVariant: 'button-secondary',
      backgroundColor: COLORS.lightestGrey,
      elevation: ELEVATIONS.Button,
      focusColor: COLORS.lighterGrey
    };
  } else if (disabled) {
    buttonConfig = {
      typoVariant: 'button-disabled',
      backgroundColor: COLORS.lightestGrey,
      elevation: ELEVATIONS.Button,
      focusColor: COLORS.lighterGrey
    };
  }

  var handleClick = function handleClick(e) {
    if (onClick) {
      onClick(e);
    }
  };

  var displayIcon;

  if (icon) {
    displayIcon = /*#__PURE__*/React.createElement(IconContainer, null, icon);
  } else if (img) {
    displayIcon = /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement("img", {
      src: img,
      width: 24,
      height: 24,
      alt: label
    }));
  }

  return /*#__PURE__*/React.createElement(Container, {
    justify: justify,
    bgColor: buttonConfig.backgroundColor,
    elevation: buttonConfig.elevation,
    fullwidth: fullwidth,
    focusColor: buttonConfig.focusColor
  }, /*#__PURE__*/React.createElement("button", _extends({
    onClick: handleClick,
    disabled: disabled,
    type: type,
    tabIndex: tabIndex
  }, props), displayIcon, /*#__PURE__*/React.createElement(Label, {
    variant: buttonConfig.typoVariant
  }, label)));
};

export { Button };
//# sourceMappingURL=Button.js.map